import * as React from "react";
import { Helmet } from "react-helmet";
import MetaTags from "../component/MetaTags";
import { motion } from "framer-motion";
import JapanHero from "../component/JapanLanding/JapanHero";
import JapanFeatures from "../component/JapanLanding/JapanFeatures";
import JapanCourses from "../component/JapanLanding/JapanCourses";
import JapanSteps from "../component/JapanLanding/JapanSteps";
import JapanDemoForm from "../component/JapanLanding/JapanDemoForm";
import JapanNavbar from "../component/JapanLanding/JapanNavbar";
import JapanFooter from "../component/JapanLanding/JapanFooter";
import { JAPAN_COURSES } from "../data/courseDataJapan";

const JAPAN_COURSE_SCHEMA = Object.values(JAPAN_COURSES).flatMap((track) =>
  track.courses.map((course) => ({
    "@context": "https://schema.org",
    "@type": "Course",
    name: `${track.label} - ${course.title}`,
    description: `Koderboxのオンラインライブレッスンによる${track.label}(${course.title})。`,
    provider: {
      "@type": "Organization",
      name: "Koderbox",
      sameAs: "https://koderbox.com",
    },
    offers: {
      "@type": "Offer",
      price: course.price,
      priceCurrency: "JPY",
      category: "Paid",
    },
  }))
);

class JapanPage extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      activeTab: "japanese",
      formLanguage: "",
      formLevel: "",
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.defer = true;
    document.body.appendChild(script);
  }

  scrollToForm = () => {
    if (typeof window !== "undefined" && this.formRef.current) {
      this.formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  scrollToCourses = () => {
    if (typeof window !== "undefined") {
      document
        .getElementById("jl-courses")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  handleBookDemo = (label, level, tab) => {
    this.setState(
      {
        formLanguage: tab,
        formLevel: level,
        activeTab: tab || this.state.activeTab,
      },
      this.scrollToForm
    );
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const pageVariants = {
      initial: { opacity: 0 },
      in: { opacity: 1 },
      out: { opacity: 0 },
    };

    const { activeTab, formLanguage, formLevel } = this.state;

    return (
      <>
        <Helmet htmlAttributes={{ lang: "ja" }}>
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="true"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;600;700;800&display=swap"
            rel="stylesheet"
          />
          <link rel="alternate" hrefLang="ja" href="https://koderbox.com/jp/" />
          <link rel="alternate" hrefLang="en" href="https://koderbox.com/demo/" />
          <link rel="alternate" hrefLang="x-default" href="https://koderbox.com/" />
        </Helmet>

        <JapanNavbar />
        <motion.div
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
        >
          <main className="jl-page">
            <JapanHero
              onBookDemo={this.scrollToForm}
              onExploreCourses={this.scrollToCourses}
            />

            <JapanFeatures />

            <JapanCourses
              activeTab={activeTab}
              onTabChange={this.handleTabChange}
              onBookDemo={this.handleBookDemo}
            />

            <JapanSteps />

            <div className="jl-section jl-google-reviews">
              <div className="section-header">
                <h3 className="highlighted-text">お客様の声</h3>
              </div>
              <section className="review-container section-bg">
                <div
                  className="elfsight-app-4aefbf62-8668-4800-b7d9-9e2e1874f0f2"
                  data-elfsight-app-lazy
                ></div>
              </section>
            </div>

            <section id="jl-demo-form" className="jl-section jl-demo-form" ref={this.formRef}>
              <div className="container">
                <header className="section-header wow fadeInUp">
                  <span className="jl-section-label">無料体験レッスン</span>
                  <h2 className="about_head">
                    今すぐ
                    <span className="highlighted-text">無料体験レッスンを予約</span>
                  </h2>
                  <p className="jl-section-subtitle">
                    定員に限りがあります。お支払いは不要です。
                  </p>
                </header>
                <div className="jl-demo-form__wrapper wow fadeInUp">
                  <JapanDemoForm
                    initialLanguage={formLanguage}
                    initialLevel={formLevel}
                  />
                </div>
              </div>
            </section>
          </main>

          <JapanFooter />
        </motion.div>

        <MetaTags
          title="Koderbox Japan | 日本語コース・英会話コース オンラインスクール"
          description="Koderboxはオンラインで学べる日本語コース・英会話コースを提供しています。ライブ授業、少人数制、資格対応。無料体験レッスン実施中。"
          path="/jp/"
          schema={JAPAN_COURSE_SCHEMA}
        />
      </>
    );
  }
}

export default JapanPage;
